import axiosRetry from 'axios-retry';
export const setupRetry = (axiosInstance, config) => {
    if (config.retry) {
        axiosRetry(axiosInstance, config.retry);
    }
};
//# sourceMappingURL=setupRetry.js.map